export const BASE_URL_API = "https://dafc-cms.styleoutlet.vn";
export const DAFC_URL = "https://dafc.com.vn/"
